import moment from 'moment';

export class 期限切れ破棄破損型 {
  期限切れ破棄破損シーケンス番号: number;
  処理日: Date | null;
  入力区分: string | null;
  商品コード: string;
  バラ数: number | null;
  数量単位: string;
  バラ単位区分: string;
  単価: number | null;
  箱単価: number | null;
  金額: number | null;
  登録日: Date;
  更新バージョン: number;

  constructor(期限切れ破棄破損シーケンス番号: number,
              処理日: Date | null,
              入力区分: string | null,
              商品コード: string,
              バラ数: number | null,
              数量単位: string,
              バラ単位区分: string,
              単価: number | null,
              箱単価: number | null,
              金額: number | null,
              登録日: Date,
              更新バージョン: number) {
    this.期限切れ破棄破損シーケンス番号 = 期限切れ破棄破損シーケンス番号;
    this.処理日 = 処理日;
    this.入力区分 = 入力区分;
    this.商品コード = 商品コード;
    this.バラ数 = バラ数;
    this.数量単位 = 数量単位;
    this.バラ単位区分 = バラ単位区分;
    this.単価 = 単価;
    this.箱単価 = 箱単価;
    this.金額 = 金額;
    this.登録日 = 登録日;
    this.更新バージョン = 更新バージョン;
  }
}

export function 期限切れ破棄破損初期値() {
  return new 期限切れ破棄破損型(0, null, null, '', null, '', '', null, null, null, new Date(), 0);
}

export function 期限切れ破棄破損新規初期値() {
  return new 期限切れ破棄破損型(0, new Date(), '期限切れ', '', null, '', '', null, null, 0, new Date(), 0);
}
